<template>
    <div class="ml-5 mr-5 mt-5" id="workers">
        <v-row>
            <v-col cols="12">
                <p class="text-left mb-0">{{ $t("workers.description") }}</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4" class="text-left">
                <v-btn class="btnCE mr-2" @click="addWorker" small color="primary">{{ $t("workers.add_worker") }}</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headerWaivers"
                    :search="search"
                    :items="peoples"
                    dense
                    item-key="id"
                    :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                    }"
                    :no-data-text="$t('dataTable.noDataText')"
                    :no-results-text="$t('dataTable.no_matching_records')"
                    :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                    }"
                >
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small class="mr-2" @click="editItem(item)">fas fa-pencil-alt</v-icon>
                        <v-icon small class="mr-2" @click="confirmDelete(item)">fas fa-trash-alt</v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" persistent max-width="670px">
            <v-card>
                <v-form ref="form" @submit.prevent="editRider">
                    <v-card-title>
                        <span class="headline">{{ $t("workers.edit_worker") }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row no-gutters class="mt-2">
                                <v-col md="6" cols="12" class="pb-0">
                                    <v-text-field
                                    v-model="form.fName"
                                    :label="$t('workers.firstName')"
                                    disabled
                                    outlined dense
                                    ></v-text-field>
                                </v-col>
                                <v-col md="6" cols="12" class="pb-0 pt-0">
                                    <v-text-field
                                    v-model="form.lName"
                                    :label="$t('workers.lastName')"
                                    disabled outlined dense
                                    ></v-text-field>
                                </v-col>
                                <v-col md="12" cols="12" class="pb-0 pt-0">
                                    <v-select 
                                    outlined dense
                                    v-model="form.relationship"
                                    :label="$t('workers.relationship')"
                                    :items="itemsRelationship"
                                    disabled
                                    :no-data-text="$t('common.no_data')"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="darken-1" dark small @click="close">{{ $t("common.close") }}</v-btn>
                        <v-btn color="darken-1" dark small @click="save">{{ $t("common.save") }}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" @cancel="dialogNotification=false;" @agree="deleteItem" type='warning'/>
    </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

const workerForm = Object.freeze({
      firstName: "",
      lastName: "",
      relationShip: ""
});

export default {
    mixins: [apiCalls],
    components: { SGSNotificationConfirm },
    data() {
        return {
            peoples: [],
            search: '',
            dialog: false,
            form: Object.assign({}, workerForm),
            editedIndex: -1,     
            workersItems: [],
            itemsRelationship: [],
            dialogNotification: false
        };
    },
    computed: {
        headerWaivers() {
            return [
                { text: this.$t("workers.livelaps_id"), align: "", value: "userId" },
                { text: this.$t("workers.firstName"), value: "fName" },
                { text: this.$t("workers.lastName"), value: "lName" },
                { text: this.$t("workers.email"), value: "email" },
                { text: this.$t("common.actions"), sortable: false, value: "actions" }
            ];
        }
    },
    methods: {
        addWorker() {
            this.$router.push({ name: "WorkerCreate" });
        },
        async getWorkers() {
            let data = { roles: [ 'Worker' ] };
            const response = await this.postApi('/api/v1/promoter/relationShip/listRoles', data);
            
            if(response.success) {
                this.peoples = response.message;
            }
        },
        close() {
            this.dialog = false;
        },
        save() {
            this.dialog = false;
        },
        editItem(item) {
            this.editedIndex = this.peoples.indexOf(item);
            this.form = Object.assign({}, item);
            this.dialog = true;
        },
        async itemsRelationship_() {
            const response = await this.getApi('/api/v1/promoter/relationShip/getRelationshipValues');
            
            if(response.success) {
                this.itemsRelationship = response.message;
            }
        },
        confirmDelete(item) {
            this.editedIndex = this.peoples.indexOf(item);
            this.form = Object.assign({}, item);
            this.dialogNotification = true;
        },
        async deleteItem() {
            const response = await this.deleteApi('/api/v1/promoter/relationShip/'+this.peoples[this.editedIndex].linkedMemberId);
            
            if(response.success) {
                this.$emit("showSnackBar",{ snack: true, msg: this.$t("common.success"), type: "success" });
                this.peoples = response.message;
                this.dialogNotification = false;
            }
        }
    }, 
    mounted() {
        
    },
    created() {
        this.getWorkers();
        this.itemsRelationship_();
    },
}
</script>